// extracted by mini-css-extract-plugin
export default {"base":"Comment_base__Fie8T","isEditor":"Comment_isEditor__pRk8C","image-style-side":"Comment_image-style-side__re2zg"};